import React from 'react';
import { Box, ChakraProvider } from '@chakra-ui/react';
import DashboardKids from '../../components/DashboardKids';



const DashboardPage = () => {
  return (
    <ChakraProvider>
      <Box p={4}>
        <DashboardKids />
      </Box>
    </ChakraProvider>
  );
};

export default DashboardPage;
